<template>
  <div class="card" v-if="hasAccess" id="printMe">
    <div class="card-header">
      <div class="row mb-2">
        <div class="col-3">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>تحویل دهنده</span>
              </div>
            </div>
            <input
              v-if="docType === 'exit'"
              disabled
              ref="server"
              :readonly="mode==='view'||sellOnly"
              v-model="server.name"
              type="text"
              class="form-control"
            >
            <input
              v-else
              ref="server"
              :readonly="mode==='view'||sellOnly"
              v-model="server.name"
              type="text"
              class="form-control"
              @click="openCompanyModal('server')"
            >
          </div>
        </div>
        <div class="col-3">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>تحویل گیرنده</span>
              </div>
            </div>
            <input
              v-if="docType === 'enter'"
              disabled
              ref="receiver"
              :readonly="mode==='view'||sellOnly"
              v-model="receiver.name"
              type="text"
              class="form-control"
            >
            <input
              v-else
              ref="receiver"
              :readonly="mode==='view'||sellOnly"
              v-model="receiver.name"
              type="text"
              class="form-control"
              @click="openCompanyModal('receiver')"
            >
          </div>
        </div>
        <div class="col-5">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نوع سند</span>
              </div>
            </div>
            <input
              v-if="sellOnly||mode==='view'"
              readonly="readonly"
              v-model="selectedDocumentType.name"
              type="text"
              class="form-control"
            >
            <vs-select
              ref="documentType"
              style="max-width:70%;"
              v-if="!sellOnly && mode!=='view'"
              :isHeader="true"
              :data="voucherTitles"
              :selectedVal="selectedDocumentType"
              :header="{label:'name'}"
              :mode="'edit'"
              @dataChanged="voucherTitleSelect"
            ></vs-select>
          </div>
        </div>

        <div class="col-1 d-flex justify-content-end">
          <button v-if="mode==='view'" class="btn btn-info mr-3" @click="onPrintClicked(voucherId)"><i class="fa fa-print"></i></button>

          <button type="button" class="close" aria-label="Close" @click="goBack">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="row mb-2">
        <!-- <div class="input-group col-sm-3"> -->
        <!-- <div class="input-group-prepend custom">
          <div class="input-group-text">
            <span>تاریخ صدور</span>
          </div>
        </div>
        <input type="text" class="form-control" readonly="readonly" :value="currentDate">-->
        <!-- </div> -->
        <div class="input-group col-sm-3">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>تاریخ فاکتور</span>
            </div>
          </div>
          <input
            v-show="mode==='view'"
            readonly="readonly"
            v-model="voucherDate"
            type="text"
            class="form-control"
          >
          <date-picker
            v-show="mode!=='view'"
            format="jYYYY-jMM-jDD"
            :auto-submit="true"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly="mode==='view'"
                v-model="voucherDate"
                class="form-control date-input"
                @click="toggleStartDatePicker"
              >
            </slot>
          </date-picker>
        </div>

        <!--<div class="col-3">-->
        <!--<div class="input-group">-->
        <!--<div class="input-group-prepend custom">-->
        <!--<div class="input-group-text">-->
        <!--<span>کد سفارش</span>-->
        <!--</div>-->
        <!--</div>-->
        <!--<input-->
        <!--:readonly="mode==='view'"-->
        <!--v-model="voucherModel.orderCode"-->
        <!--type="text"-->
        <!--class="form-control"-->
        <!--&gt;-->
        <!--</div>-->
        <!--</div>-->
        <div class="col-3">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>شماره فاکتور/بارنامه</span>
              </div>
            </div>
            <input
              :readonly="mode==='view'"
              v-model="voucherModel.invoiceNumber"
              type="text"
              class="form-control"
            >
          </div>
        </div>

        <div class="col-5">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>کد سفارش</span>
              </div>
            </div>
            <input
              v-if="sellOnly||mode==='view'"
              readonly="readonly"
              v-model="voucherModel.orderCode"
              type="text"
              class="form-control"
            >
            <vs-select
              ref="order"
              style="max-width:70%;"
              v-if="!sellOnly && mode!=='view'"
              :isHeader="true"
              :data="orders"
              :selectedVal="selectedOrder"
              :header="{label:'name'}"
              :mode="'edit'"
              @dataChanged="orderSelect"
            ></vs-select>
          </div>
        </div>


        <!--<div class="col-2">-->
        <!--<input-->
        <!--v-if="mode==='edit'||mode==='view'"-->
        <!--readonly="readonly"-->
        <!--v-model="voucherModel.voucherNumber"-->
        <!--type="text"-->
        <!--class="form-control"-->
        <!--&gt;-->
        <!--</div>-->
      </div>


      <div class="row">
        <div class="col-4">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نام تحویل دهنده/گیرنده</span>
              </div>
            </div>
            <input
              :readonly="mode==='view'"
              v-model="voucherModel.voucherNumber"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="input-group col-7">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>توضیحات</span>
            </div>
          </div>
          <input
            :readonly="mode==='view'"
            v-model="voucherModel.description"
            type="text"
            class="form-control"
          >
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <vs-table
            v-if="show"
            :params="params"
            :options="options"
            @onCreateHeaderActionClicked="openProductModal"
          ></vs-table>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row mb-4">
        <div class="col-sm-9"></div>
        <div class="input-group col-sm-3">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>جمع کل</span>
            </div>
          </div>
          <input v-model="rowsPrice.toLocaleString()" type="text" class="form-control" readonly="readonly">
        </div>
      </div>
      <div class="row mb-2">
        <div class="input-group col-sm-3">
          <div class="input-group-prepend custom" v-if="mode==='view'||mode==='edit'">
            <div class="input-group-text">
              <span>صادرکننده</span>
            </div>
          </div>
        </div>
        <div class="input-group col-sm-3">
          <div class="input-group-prepend custom" v-if="mode==='view'||mode==='edit'">
            <div class="input-group-text">
              <span>تائید انباردار</span>
            </div>
          </div>
        </div>
        <div class="input-group col-sm-3">
          <div class="input-group-prepend custom" v-if="mode==='view'||mode==='edit'">
            <div class="input-group-text">
              <span>تائید مدیر</span>
            </div>
          </div>
        </div>
        <div class="col-sm-2" :class="mode==='view'?'d-none':''">
          <button class="btn btn-success" @click="submit">
            <span v-if="mode==='create'">ثبت رسید</span>
            <span v-if="mode==='edit'">ویرایش رسید</span>
          </button>
        </div>
      </div>
    </div>
    <b-modal
      ref="modal"
      title="انتخاب کالا"
      size="xl"
      ok-only
      ok-title="تایید"
      @ok="openProductDetailModal"
    >
      <div ref="productsContainer">
        <products
          :is-select-mode="true"
          @onRowSelect="selectProduct"
          @onRowDoubleClicked="openProductDetailModal"
        ></products>
      </div>
    </b-modal>
    <b-modal
      ref="selectCompany"
      title="انتخاب شرکت"
      size="lg"
      ok-only
      ok-title="تایید"
      @ok="onSelectCompany"
    >
      <bd-select-company-modal
        :partyType="partyType"
        @selectCompany="selectCompany"
        @onRowDoubleClicked="onCompanyDoubleClicked"
      ></bd-select-company-modal>
    </b-modal>
    <div ref="container"></div>
  </div>
</template>

<script>
  import VsTable from "../_framework/VsTable.vue";
  import EventBus from "../bus.js";
  import Products from "./Products.vue";
  import Moment from "moment-jalali";
  import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import VsSelect from "../_framework/VsSelect";
  import BaseService from "../_framework/api/BaseService.js";
  import BdSelectCompanyModal from "../components/BDSelectCompanyModal.vue";
  import BdProductVoucherModal from "../components/BDProductVoucherModal.vue";
  import {mapState, mapMutations, mapActions} from "vuex";
  import Vue from "vue";
  import VueHtmlToPaper from 'vue-html-to-paper';
  import SetVoucherProductDetails from "../components/SetVoucherProductDetails.vue";

  export default {
    name: "voucher",
    components: {
      VsTable,
      Moment,
      datePicker: DatePicker,
      VsSelect,
      BdSelectCompanyModal,
      Products,
      SetVoucherProductDetails
    },
    data() {
      return {
        docType: "",
        sellOnly: false,
        hasAccess: true,
        access: {},
        show: true,
        selectedDocumentType:
          {
            id: 0,
            name: null,
            type: {
              name: null,
              value: null
            }
          },
        voucherDate: null,
        voucherId: null,
        documentTypes: [],
        voucherTitles: [],
        voucherModel: {
          voucherProductDto: []
        },
        rowsPrice: 0,
        selectedCompany: {},
        selectedProduct: {},
        productVoucherModel: {},
        server: {},
        receiver: {},

        partyType: "",
        currentDate: Moment().format("jYYYY/jMM/jDD"),
        params: {
          entity: "voucher",
          list: [],
          headers: {
            productId: {
              title: "ردیف",
              type: "number",
              rowAlignment: "center",

            },
            productCode: {
              title: "کد کالا",
              type: "text",
              rowAlignment: "center"
            },
            productName: {
              title: "نام کالا",
              type: "text",
              rowAlignment: "center"
            },
            number: {
              title: "تعداد",
              type: "number",
              rowAlignment: "center",
              grow: 0.4
            },
            unit: {
              title: "واحد",
              type: "number",
              rowAlignment: "center"
            },
            details: {
              title: "جزییات محصول",
              type: "custom",
              component: SetVoucherProductDetails,
              rowAlignment: "center",
              // multiple: true,
              // label: "productName",
              inHeader: true
              // listParams: {
              //   requestURI: "products"
              // }
            },
            price: {
              title: "فی",
              type: "price",
              rowAlignment: "center"
            },
          totalPrice: {
              title: "قیمت",
              type: "price",
              rowAlignment: "center"
            }
          }
        },
        options: {
          dataSourceType: "store",
          hasActions: true,
          onRowClicked: row => {
          },
          hasActionsInHeader: true,
          clickableRows: true,
          // isPrintable: true,
          onCreateHeaderActionClicked: true,
          onEditClicked: (row, context) => {
            this.productVoucherModel = row;
            this.productVoucherModel.mode = "edit";
            this.openProductDetailModal();
          },
          onRowDoubleClicked: row => {
            this.productVoucherModel = row;
            this.productVoucherModel.mode = "view";
            this.openProductDetailModal();
          },
          beforeDeleteEntity: input => {
            this.deleteVoucherProductsRow(input.id);
            return null;
          }
        },
        orders: [],
        selectedOrder: null
        // {
        //   code: 0,
        //   id: 0,
        //   receiverName: "",
        //   serveName: "",
        //   description: "",
        //
        // },
      };
    },
    methods: {
      onPrintClicked(id) {

        this.$router.push(
          {
            name: "پرینت ووچر",
            params: {
              id: id
            }
          }
        );
      },
      goBack() {
        this.$router.push({name: "اسناد انبار"});
      },
      voucherTitleSelect(prop, data) {
        if (data && data.id) {
          this.voucherModel.documentTypeId = data.id;
        } else {
          this.voucherModel.documentTypeId = null;
        }
      },
      orderSelect(prop, data) {
        // console.log(data)
        if (data && data.orderCode) {
          this.voucherModel.orderCode = data.orderCode;
        } else {
          this.voucherModel.orderId = null;
        }
      },

      onCompanyDoubleClicked() {
        this.onSelectCompany();
        if (this.$refs && this.$refs.selectCompany) {
          this.$refs.selectCompany.hide();
        }
      },
      setVoucherTitles() {
        let type = 0;
        // console.log("select type" + this.voucherModel.serveOutSourceId, this.voucherModel.serveCompanyId)
        if (this.voucherModel.serveOutSourceId || this.voucherModel.serveCompanyId) {
          type = 1;
        } else {
          type = 2;
        }

        if (type === 0) return;

        new BaseService("documentTypes").getList().then(rs => {
          this.documentTypes = rs.data;
          this.voucherTitles = this.documentTypes.filter(dt => {
            return dt.type.value === type;
          });
        });
      },
      onSelectCompany(e) {
        // console.log(this.selectedCompany);
        this.voucherModel.serveCompanyId = null;
        this.voucherModel.serveOutSourceId = null;
        this.voucherModel.receiveOutSourceId = null;
        this.voucherModel.receiverCompanyId = null;

        if (this.partyType === "server") {
          this.server = this.selectedCompany;
          this.receiver.name = localStorage.getItem("company");

          if (this.selectedCompany.type === "outsource") {
            this.voucherModel.serveOutSourceId = this.selectedCompany.id;
          } else {
            this.voucherModel.serveCompanyId = this.selectedCompany.id;
          }
        } else {
          this.receiver = this.selectedCompany;
          this.receiver.name = this.selectedCompany.name || this.selectedCompany.companyName;
          this.server.name = localStorage.getItem("company");
          if (this.selectedCompany.type === "outsource") {
            this.voucherModel.receiveOutSourceId = this.selectedCompany.id;
          } else {
            this.voucherModel.receiverCompanyId = this.selectedCompany.id;
          }
        }

        this.setVoucherTitles();
      },
      selectCompany(data) {
        this.selectedCompany = data;
      },
      openCompanyModal(partyType) {
        if (this.sellOnly) {
          return;
        }
        if (this.mode === "view") {
          return;
        } else {
          if (this.partyType === partyType) {
            this.$refs.selectCompany.show();
          } else if (this.partyType !== partyType) {
            this.$refs.documentType.$data.selectedValue = null;
            this.voucherModel.documentTypeId = null;
            this.partyType = partyType;
            this.$refs.selectCompany.show();
          }
        }
      },
      selectProduct(prod) {
        this.selectedProduct = prod;
        this.productVoucherModel = {};
        this.productVoucherModel.productName = prod.productName;
        this.productVoucherModel.title1 = prod.title1;
        this.productVoucherModel.title2 = prod.title2;
        this.productVoucherModel.productId = prod.id;
        this.productVoucherModel.productCode = prod.productCode;
        this.productVoucherModel.unit = prod.unit;
        this.productVoucherModel.stock = prod.stock;
        this.productVoucherModel.mode = "Create";
      },
      changepvmData(pvmData) {
        this.productVoucherModel = pvmData;
      },
      openProductDetailModal(prod) {
        // console.log(this.productVoucherModel)
        this.productVoucherModel.partyType = this.partyType;
        this.$refs.modal.hide();
        let ComponentClass = Vue.extend(BdProductVoucherModal);
        let pdModal = new ComponentClass({
          propsData: {
            model: this.productVoucherModel
          }
        });
        pdModal.$mount();
        this.$refs.container.appendChild(pdModal.$el);
        setTimeout(() => {
          pdModal.openModal();
        }, 400);
        pdModal.$on("onProductVoucherModalOk", mode => {
          if (mode === "create") {
            this.addVoucherRow();
          }
          if (mode === "update") {
            this.updateVoucherRow();
          }
        });
        // this.$refs.productDetail.show();
      },
      openProductModal() {
        let selectedProductIds = [];
        this.voucherModel.voucherProductDto.map(p => {
          selectedProductIds.push(p.productId);
        });
        if (this.voucherModel && !this.voucherModel.documentTypeId) {
          this.$noty.error("ابتدا نوع سند را انتخاب نمائید");
          return;
        }

        let ComponentClass = Vue.extend(Products);
        let _products = new ComponentClass({
          propsData: {isSelectMode: "true"},
          store: this.$store
        });
        if (this.partyType === "receiver") {
          _products.options.beforeFetchEntityList = function (params) {
            params.havestock = true;
            if (selectedProductIds.length > 0) {
              params.selectedProductIds = selectedProductIds;
            }
            return params;
          };
          _products.options.getTopLeftButtons = function (input) {
            let arr = [];
            let addItemButton = {
              component: "toggle-table-actions-button",
              params: {
                onClick() {
                  _products.options.hasActions = !_products.options.hasActions;
                }
              }
            };
            arr.push(addItemButton);
            return arr;
          };
        } else {
          _products.options.beforeFetchEntityList = function (params) {
            if (selectedProductIds.length > 0) {
              params.selectedProductIds = JSON.stringify(selectedProductIds);
            }
            return params;
          };
        }
        _products.$mount();
        if (this.$refs.productsContainer) {
          if (this.$refs.productsContainer.hasChildNodes()) {
            this.$refs.productsContainer.removeChild(
              this.$refs.productsContainer.childNodes[0]
            );
          }
          this.$refs.productsContainer.appendChild(_products.$el);
        }
        if (this.$refs && this.$refs.modal) {
          this.$refs.modal.show();
        }
        _products.$on("onRowSelect", row => {
          this.selectProduct(row);
        });
        _products.$on("onRowDoubleClicked", row => {
          this.openProductDetailModal(row);
        });
      },
      setDateFromDatePicker(date) {

        this.voucherModel.voucherDate = date;
        this.voucherDate = date;
      },
      toggleStartDatePicker() {

        this.$refs.datePicker.togglePicker();
      },
      hideModal() {
        this.$refs.modal.hide();
      },
      addVoucherRow() {
        let data = JSON.parse(JSON.stringify(this.productVoucherModel));
        this.addVoucherProducts(data);
      },
      updateVoucherRow() {
        let data = JSON.parse(JSON.stringify(this.productVoucherModel));
        this.updateVoucherProducts(data);
      },
      addVoucherProducts(data) {
        let number = data.number || data.unitVal;
        this.voucherModel.voucherProductDto.push({
          stock: data.stock + number,
          productId: data.productId,
          productCode: data.productCode,
          unitVal: number,
          price: data.price || 0,
          productName: data.productName
        });
        this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
          stock: data.stock + number,
          productId: data.productId,
          productCode: data.productCode,
          productName: data.productName,
          unit: data.unit.unitValue,
          price: data.price || 0,
          number: number,
          totalPrice: data.price * (data.number || data.unitVal) || 0,
          description: data.description
        });
        this.refreshVoucherProductsTable();
      },
      updateVoucherProducts(data) {
        this.voucherModel.voucherProductDto = this.voucherModel.voucherProductDto.map(
          vp => {
            if (vp.id === data.id) {
              vp.productId = data.productId;
              vp.productCode = data.productCode;
              vp.unitVal = data.number || data.unitVal;
              vp.price = data.price;
              vp.productName = data.productName;
            }
            return vp;
          }
        );
        this.refreshVoucherProductsTable();
      },
      deleteVoucherProductsRow(id) {
        this.$store.commit("DELETE_ROW_FROM_VS_TABLE_FEED", id);
        this.voucherModel.voucherProductDto = this.voucherModel.voucherProductDto.filter(
          vp => {
            return vp.id !== id;
          }
        );
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 1);
      },
      refreshVoucherProductsTable() {
        this.rowsPrice = 0;
        let id = 0;
        this.vsTableFeed.map(p => {
          id = id + 1;
          p.id = id;
          this.rowsPrice = this.rowsPrice + p.totalPrice;
        });
        id = 0;
        this.voucherModel.voucherProductDto.map(p => {
          id = id + 1;
          p.id = id;
        });

      },
      submit() {

        if (this.voucherModel.voucherDate == null) {
          // var ddd = Moment(new Date(),"YYYY/MM/DD");
          // var ss = ddd.format("YYYY/MM/DD");
          // this.voucherModel.voucherDate =Moment(new Date().getFullYear(),"YYYY/MM/DD");
          // console.log(this.voucherModel.voucherDate);
          // console.log(ddd);
          // console.log(ss);
          // var currentDate = new Date();
          // console.log(currentDate);
          var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
          // console.log(currentDateWithFormat);
          this.voucherModel.voucherDate = currentDateWithFormat;
        } else {
          if (this.voucherModel.voucherDate) {
            let date = Moment(this.voucherModel.voucherDate, "jYYYY/jMM/jDD");
            this.voucherModel.voucherDate = date.format("YYYY/MM/DD");
          }
        }
        if (this.mode === "create") {
          new BaseService("voucher").create(this.voucherModel).then(rs => {
            this.$router.push({name: "اسناد انبار"});
          });
        } else if (this.mode === "edit") {
          new BaseService("voucher").update(this.voucherModel).then(rs => {
            this.$store.commit("RESET_VS_TABLE_FEED", []);
            this.$router.push({name: "اسناد انبار"});
          });
        }
      },
      setDataItem(model) {
        /*let date = Moment(model.voucherDate,"YYYY/MM/DD"  );
        model.voucherDate = date.format("jYYYY/jMM/jDD");*/
        if (model.documentType.id) {
          setTimeout(() => {
            this.selectedDocumentType = model.documentType;
          })
        } else {
          this.selectedDocumentType = null;
        }
        this.voucherModel.voucherNumber = model.voucherNumber;
        this.voucherModel.id = model.id;
        this.server.name = model.serveName;
        this.receiver.name = model.receiverName;
        if (model.documentType.type === 1) {
          this.voucherModel.serveOutSourceId = model.serveOutSourceId;
          this.partyType = "server";
          this.docType = "enter";
        } else {
          this.docType = "exit";

          if (model.receiveOutSourceId) {
            this.voucherModel.receiveOutSourceId = model.receiveOutSourceId;
          } else if (model.receiverCompanyId) {
            this.voucherModel.receiverCompanyId = model.receiverCompanyId;
          }
          this.partyType = "receiver";
        }
        this.voucherModel.voucherNumber = model.voucherNumber;
        this.voucherModel.orderCode = model.orderCode;
        this.selectedOrder = model.orderCode;
        this.voucherDate = model.voucherDate.substring(0, 10);
        this.voucherModel.voucherDate = model.voucherDate;
        this.voucherModel.invoiceNumber = model.invoiceNumber;
        this.voucherModel.description = model.description;
        this.voucherModel.documentTypeId = model.documentType.id;

        model.products.map(p => {
          this.addVoucherProducts(p);
        });
        // console.log(model)
        // console.log(this.voucherModel)
      }
    },
    mounted() {
      EventBus.$on("selectTreeNode", data => {
        data.type = "company";
        this.selectCompany(data);
      });
      // const printoptions = {
      //   name: '_blank',
      //   specs: [
      //     'fullscreen=yes',
      //     'titlebar=yes',
      //     'scrollbars=yes',
      //
      //   ],
      //   styles: [
      //     'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
      //     'https://unpkg.com/kidlat-css/css/kidlat.css',
      //
      //   ],
      //   timeout: 1000, // default timeout before the print window appears
      //   autoClose: false, // if false, the window will not close after printing
      //   windowTitle: window.document.title,
      // };
      // Vue.use(VueHtmlToPaper, printoptions);
    },
    beforeMount() {
      this.options.access = checkAccess(this.$route.path);
      this.hasAccess = !!this.options.access;
      this.$store.commit("RESET_VS_TABLE_FEED", []);
      this.voucherModel.voucherProductDto = [];
      if (this.$route.query._mode === "view") {
        this.options.hasActions = false;
      }
      if (this.$route.query.id) {
        this.voucherId = this.$route.query.id;
        new BaseService("voucher").getById(this.$route.query.id).then(rs => {
          this.model = rs.data;
          if (this.model) {
            this.setDataItem(this.model);
          }
        });
      }
      if (this.$route.query._data && this.$route.query._data._docType == null) {
        this.sellOnly = false;
        let _data = JSON.parse(this.$route.query._data);
        this.setDataItem(_data);
      } else if (this.$route.query._mode === "create") {
        // this.selectedDocumentType = null;
        // new BaseService("Report", "/GetDashboardOrders").getList().then(rs => {
        //   this.orders = rs.data;
        //   for (const dt of this.orders) {
        //     dt.name = dt.orderCode + "/" + dt.description+ "/" + dt.companyName;
        //   }
        //
        // });
      }


      if (this.$route.query._data && this.$route.query._data._docType === "enter") {
        this.docType = "enter";
        this.receiver.name = localStorage.getItem("company");


        // console.log("2222")
        this.selectedDocumentType = null;
        new BaseService('ProductionManagements', '/GetManageBuyOrder').getList().then(rs => {
          this.orders = rs.data.data;
          for (const dt of this.orders) {
            dt.name =  dt.orderCode
              + "-" + dt.deliveryDate
              + "-" + dt.description
              + "-" + dt.customer.name;
          }

        });

      } else if (this.$route.query._data && this.$route.query._data._docType === "exit") {
        this.docType = "exit";
        // console.log("1111")
        this.server.name = localStorage.getItem("company");
        this.selectedDocumentType = null;
        new BaseService("Report", "/GetDashboardOrders").getList().then(rs => {
          this.orders = rs.data;
          for (const dt of this.orders) {
            dt.name =  dt.orderCode
              + "-" + dt.deliveryDate
              + "-" + dt.description;
              // + "-" + dt.customer.name;
          }

        });
      }

      new BaseService("documentTypes").getList().then(rs => {
        this.documentTypes = rs.data;
        this.voucherTitles = this.documentTypes.filter(dt => {
          if (this.docType === "enter") {
            return dt.type.value === 1;
          }
          if (this.docType === "exit") {
            return dt.type.value === 2;
          }
        });
      });

      // this.setVoucherTitles();
    },
    watch: {
      vsTableFeed(val) {
        this.refreshVoucherProductsTable();
      }
    },
    computed: {
      ...mapState(["vsTableFeed", "tableRowIndex"]),
      mode() {
        return this.$route.query._mode;
      }
    }
  };
</script>

<style scoped>
  .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  }

  .v-select .dropdown-toggle input {
    width: 100% !important;
  }
</style>
